import { observer } from "mobx-react";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import { useHistory } from "react-router";
import historyStore from './stores/HistoryStore';

// @ts-ignore
import AlertTemplate from "react-alert-template-basic";

import { useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { getSupervisor } from "./api/supervisor";
import { Loader } from "./components/Loader";
import {
  generateKeys,
  stringifyPublicKey,
  stringifyPrivateKey,
} from "./helpers/crypto";
import RouterWithoutSupervisor from "./RouterWithoutSupervisor";
import RouterWithSupervisor from "./RouterWithSupervisor";
import supervisorStore from "./stores/SupervisorStore";
import translationsStore from "./stores/TranslationsStore";
import { initializeTranslations } from "./translations/config";
import {
  getPrivateKeyPem,
  getPublicKeyPem,
  getSelectedLocale,
  getSupervisorId,
  setPrivateKeyPem,
  setPublicKeyPem,
} from "./utils/localStorage";
initializeTranslations();

const queryClient = new QueryClient();

const App = () => {
  const [isLoadingTranslatios, setIsLoadingTranslations] = useState(true);
  const [isLoadingSupervisor, setIsLoadingSupervisor] = useState(true);
  const history = useHistory();
  useEffect(() => {
    historyStore.history = history;
    initializeEncryption();
    initializeTranslations().then(() => {
      const supervisorId = getSupervisorId();
      if (supervisorId) {
        getSupervisor(supervisorId)
          .then((supervisor) => {
            supervisorStore.setSupervisor(supervisor);
            setIsLoadingSupervisor(false);
          })
          .catch((error) => {
            setIsLoadingSupervisor(false);
          });
      } else {
        setIsLoadingSupervisor(false);
      }
    });
  }, [history]);
  const initializeTranslations = () => {
    const locale = getSelectedLocale() || "en";
    return translationsStore.setSelectedLanguage(locale).then(() => {
      setIsLoadingTranslations(false);
      return Promise.resolve();
    });
  };
  const initializeEncryption = async () => {
    const privateKeyPem = getPrivateKeyPem();
    const publicKeyPem = getPublicKeyPem();
    if (!privateKeyPem || !publicKeyPem) {
      const keys = await generateKeys();
      const publicKey = await crypto.subtle.exportKey("spki", keys.publicKey);
      const privateKey = await crypto.subtle.exportKey(
        "pkcs8",
        keys.privateKey
      );

      setPrivateKeyPem(stringifyPrivateKey(privateKey));
      setPublicKeyPem(stringifyPublicKey(publicKey));
    }
  };
  if (isLoadingTranslatios || isLoadingSupervisor) {
    return (
      <div className="centralized">
        <Loader />
      </div>
    );
  }

  const alertOptions = {
    // you can also just use 'bottom center'
    position: positions.BOTTOM_CENTER,
    timeout: 3000,
    offset: "30px",
    // you can also just use 'scale'
    transition: transitions.SCALE,
  };

  return (
    <AlertProvider template={AlertTemplate} {...alertOptions}>
      <QueryClientProvider client={queryClient}>
        {!supervisorStore.supervisor ? (
          <RouterWithoutSupervisor />
        ) : (
          <RouterWithSupervisor />
        )}
      </QueryClientProvider>
    </AlertProvider>
  );
};

export default observer(App);
